import { Injectable } from '@angular/core';

@Injectable()
export class LoggerService {
    error = console.error.bind(console);
    info = console.info.bind(console);
    success = console.info.bind(console);
    warning = console.warn.bind(console);
}
